import React from "react";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { MdNotificationsActive, MdSearch } from "react-icons/md";
import api from "utils/apiService";

const DARK_KEY = "dashboard.dark";

function applyDark(enabled) {
  const root = document.body;
  if (enabled) root.classList.add("dark");
  else root.classList.remove("dark");
}

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const location = useLocation();
  const [notificationCount, setNotificationCount] = React.useState(0);

  React.useEffect(() => {
    try {
      applyDark(window.localStorage.getItem(DARK_KEY) === "1");
    } catch (e) {
      /* ignore */
    }
  }, []);

  React.useEffect(() => {
    let mounted = true;

    const fetchNotificationCount = async () => {
      const res = await api.get("/notifications/getNumberUnseenNotifications");
      if (!mounted) return;
      setNotificationCount(res?.error ? 0 : Number(res?.data || 0));
    };

    fetchNotificationCount();
    const intervalId = window.setInterval(fetchNotificationCount, 30000);
    window.addEventListener("focus", fetchNotificationCount);
    document.addEventListener("visibilitychange", fetchNotificationCount);

    return () => {
      mounted = false;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", fetchNotificationCount);
      document.removeEventListener("visibilitychange", fetchNotificationCount);
    };
  }, [location.pathname]);

  const triggerQuickJump = () => {
    const evt = new KeyboardEvent("keydown", {
      key: "k",
      metaKey: true,
      bubbles: true,
    });
    window.dispatchEvent(evt);
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ms-[6px]">
        <p className="shrink text-[24px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-12 items-center justify-around gap-2 rounded-full bg-white px-3 py-2 shadow-card transition-all hover:shadow-card-hover dark:!bg-navy-800">
        <button
          type="button"
          onClick={triggerQuickJump}
          className="hidden items-center gap-2 rounded-md px-2 py-1 text-xs text-gray-500 hover:bg-surface-muted dark:hover:bg-navy-700 md:flex"
          title="بحث سريع"
        >
          <MdSearch className="h-4 w-4" />
          <span>بحث</span>
          <kbd className="rounded border border-border bg-surface-muted px-1.5 py-0.5 font-mono text-[10px] text-gray-500">
            Ctrl K
          </kbd>
        </button>

        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-6 w-6" />
        </span>

        <Link
          to="/admin/notifications"
          aria-label="الإشعارات"
          title="الإشعارات"
          className="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-gray-600 hover:bg-surface-muted dark:text-white dark:hover:bg-navy-700"
        >
          <MdNotificationsActive className="h-5 w-5" />
          {notificationCount > 0 ? (
            <>
              <span className="absolute -top-0.5 -end-0.5 h-3 w-3 animate-ping rounded-full bg-danger-500 opacity-75" />
              <span className="absolute -top-1.5 -end-1.5 min-w-[18px] rounded-full border-2 border-white bg-danger-600 px-1 text-center text-[10px] font-bold leading-[16px] text-white dark:border-navy-800">
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            </>
          ) : null}
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
